import { combineReducers } from "redux";
import { authentication } from "./authentication.reducer";
import system from "./system.reducer";
import yodaAgent from "./yodaAgent.reducer";
import yodaInfo from "./yodaInfo.reducer";
import yodaCatalogue from "./yodaCatalogue.reducer";
import yodaOrders from "./yodaOrders.reducer";
import users from "./users.reducer";
import yodaStakeholders from "./yodaStakeholder.reducer";
import yodaCustomer from "./yodaCustomer.reducer";
import yodaIdentity from "./yodaIdentity.reducer";
import yodaBudget from "./yodaBudget.reducer";
import yodaMessages from "./yodaMessage.reducer";
import layout from "./layout.reducer";

const rootReducer = combineReducers({
  layout,
  system,
  authentication,
  users,
  yodaAgent,
  yodaInfo,
  yodaCatalogue,
  yodaOrders,
  yodaStakeholders,
  yodaCustomer,
  yodaIdentity,
  yodaBudget,
  yodaMessages,
});

export { rootReducer };
